import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Popconfirm,
  Row,
  Skeleton,
} from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  createShipping,
  deleteShipping,
  getShipping,
  updateShipping,
} from "../../../actions/shipping";
import { useNavigate, useParams } from "react-router-dom";

const Shipping = ({ currentUser, storeCurrency }) => {
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [, forceUpdate] = useState({});
  const { id } = useParams();
  const shipping = useSelector((state) => state.shipping);

  useEffect(() => {
    setLoading(true);
    setLoadingButton(false);
    forceUpdate({});
    if (id) {
      dispatch(getShipping(id));
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const dispatch = useDispatch();
  const history = useNavigate();
  const [form] = Form.useForm();

  const onFinish = (value) => {
    if (id) {
      setLoadingButton(true);
      let formData = {
        ...value,
        user: currentUser?.id,
        store: currentUser?.store,
      };
      dispatch(updateShipping(id, formData, history, setLoadingButton));
    } else {
      setLoadingButton(true);
      let formData = {
        ...value,
        user: currentUser?.id,
        store: currentUser?.store,
      };
      dispatch(createShipping(formData, history, setLoadingButton));
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      name: shipping?.name,
      value: shipping?.value,
      description: shipping?.description,
    });
  }, [shipping]);

  const deleteShippingFun = () => {
    dispatch(deleteShipping(id, history));
  };

  return (
    <Dashboard title={`${id ? "View" : "Add"} Shipping`}>
      <div className="p-4 shadow bg-white mt-2 mb-6 flex items-center justify-between">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/store">Store</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{`${id ? "View" : "Add"} Shipping`}</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        form={form}
        autoComplete="off"
      >
        <div className="md:grid md:grid-cols-3 md:gap-6 mb-4">
          <div className="mt-5 md:mt-0 md:col-span-2 px-4 py-5 sm:p-6 bg-white shadow">
            <Skeleton loading={loading}>
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please input shipping name!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Price"
                    name="value"
                    rules={[
                      {
                        required: true,
                        message: "Please input shipping price!",
                      },
                    ]}
                  >
                    <Input prefix={storeCurrency} type="number" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Description"
                    name="description"
                    rules={[
                      {
                        required: true,
                        message: "Please input description!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Skeleton>
          </div>
          <div className="md:col-span-1">
            <div className="bg-white shadow px-4 py-5 sm:p-6">
              <Skeleton loading={loading}>
                <Row gutter={16}>
                  <Col span={24}>
                    <div className="flex flex-wrap  justify-center gap-4 my-7">
                      <Button href="/products">Cancel</Button>
                      <Form.Item shouldUpdate style={{ marginBottom: 0 }}>
                        {() => (
                          <Button
                            type="primary"
                            htmlType="submit"
                            disabled={
                              !form.isFieldsTouched() ||
                              !!form
                                .getFieldsError()
                                .some(({ errors }) => errors.length).length
                            }
                            loading={loadingButton}
                          >
                            {`${id ? "Update" : "Save"} Shipping`}
                          </Button>
                        )}
                      </Form.Item>
                      {id ? (
                        <Popconfirm
                          title="Are you sure to delete this shipping?"
                          onConfirm={deleteShippingFun}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button danger type="primary">
                            Delete
                          </Button>
                        </Popconfirm>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
              </Skeleton>
            </div>
          </div>
        </div>
      </Form>
    </Dashboard>
  );
};

export default Shipping;
